import { observer } from 'mobx-react-lite'
import { ProductSearchResultHeader } from './ProductSearchResultHeader'
import {
	ProductList,
	ProductListItemClickHandle,
	ProductListItemOnPriceChange,
} from './ProductList'
import React from 'react'
import {
	CATEGORY_HANDOUT_PAGE,
	CATEGORY_TEXTBOOK_PAGE,
	CATEGORY_WORKBOOK_PAGE,
} from '@/settings/constant'
import { ProductUnifiedSearchResultWrapper } from '@/modules/products/components/ProductTypeSearchResult'
import { Menu } from 'antd'
import { ActiveLink } from '@/components/ActiveLink'

export interface ProductUnifiedSearchResultProps {
	keywords: string
	onItemClick: ProductListItemClickHandle
	onPriceChange: ProductListItemOnPriceChange
	onEmptyClick: () => void
}

export const ProductUnifiedSearchResult = observer<ProductUnifiedSearchResultProps>(
	({ keywords, onItemClick, onEmptyClick, onPriceChange }) => {
		return (
			<ProductUnifiedSearchResultWrapper>
				{/* [모바일용] 수업자료/교과서라이선스/참고서라이선스 메뉴 버튼 */}
				<Menu mode={'horizontal'}>
					<Menu.Item key="0">
						<ActiveLink href={`${CATEGORY_HANDOUT_PAGE}`}>수업자료</ActiveLink>
					</Menu.Item>
					<Menu.Item key="1">
						<ActiveLink href={`${CATEGORY_TEXTBOOK_PAGE}`}>교과서</ActiveLink>
					</Menu.Item>
					<Menu.Item key="2">
						<ActiveLink href={`${CATEGORY_WORKBOOK_PAGE}`}>참고서</ActiveLink>
					</Menu.Item>
				</Menu>

				<div className="section">
					<ProductSearchResultHeader
						count={0}
						goToUrl={CATEGORY_HANDOUT_PAGE}
						title={'수업자료'}
					/>

					<ProductList
						onPriceChange={onPriceChange}
						onClick={onItemClick}
						dataSource={[]}
						onEmptyClick={onEmptyClick}
						// keyword={keywords}
						isAllList={true}
					/>
				</div>

				<div className="section">
					<ProductSearchResultHeader
						count={0}
						goToUrl={CATEGORY_TEXTBOOK_PAGE}
						title={'교과서 라이선스'}
					/>
					<ProductList
						onPriceChange={onPriceChange}
						onClick={onItemClick}
						dataSource={[]}
						onEmptyClick={onEmptyClick}
						isAllList={true}
						// keyword={keywords}
					/>
				</div>

				<div className="section">
					<ProductSearchResultHeader
						count={0}
						goToUrl={CATEGORY_WORKBOOK_PAGE}
						title={'참고서 라이선스'}
					/>
					<ProductList
						onPriceChange={onPriceChange}
						onClick={onItemClick}
						dataSource={[]}
						onEmptyClick={onEmptyClick}
						isAllList={true}
						// keyword={keywords}
					/>
				</div>
			</ProductUnifiedSearchResultWrapper>
		)
	},
)
